<template>
    <div class="progress-bar">
        <div class="current-progress" ref="div"></div>
    </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";

export default {
    name: "ProgressBar",
    props: {
        step: {
            type: Number
        },
        maxStep: {
            type: Number
        }
    },

    setup(props) {
        const div = ref(null);

        onMounted(() => {
            const width = (props.step / props.maxStep * 100).toString() + '%';
            div.value.style.width = width;
        })

        watch(() => props.step, (newValue, oldValue) => {
            const width = (newValue / props.maxStep * 100).toString() + '%';
            div.value.style.width = width;
        })

        return { div }
    }
}
</script>

<style lang="scss">
.progress-bar {
    background-color: #ccc;
    border-radius: 1rem;
    width: 100%;

    .current-progress {
        border-radius: 1rem;
        height: 14px;
        background: linear-gradient(
            90deg,
            rgba(55, 68, 115, 1) 0%,
            rgba(100, 55, 115, 1) 61%
        );

        transition: all 0.5s ease-in-out;
        position: relative;
    }
}
</style>